export const actions = {
    SET_FORMS: "SET_FORMS",
    SHOW_FORM: "SHOW_FORM",
};

export const setForms = () => {
    return  {
        type: actions.SET_FORMS,
    }
};

export const showForm = (openForm, Id) => {
    return (dispatch) => {
        dispatch({
            type: actions.SHOW_FORM,
            openForm,
            Id,
        })
    }
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/forms.js